import {type ElementPosition} from './get-element-position';

export function clampToScreen(pos: ElementPosition, padding = 0): ElementPosition {
  const minX = scrollX + padding;
  const maxX = scrollX + innerWidth - padding;
  const minY = scrollY + padding;
  const maxY = scrollY + innerHeight - padding;

  if (pos.left >= minX && pos.right <= maxX
    && pos.top >= minY && pos.bottom <= maxY) {
    return pos;
  }

  const updated = {...pos};

  if (pos.left < minX) {
    updated.left = minX;

    if (minX + pos.width > maxX) {
      updated.right = maxX;
      updated.width = updated.right - updated.left;
    } else {
      updated.right = minX + pos.width;
    }
  } else if (pos.right > maxX) {
    updated.right = maxX;

    if (maxX - pos.width < minX) {
      updated.left = minX;
      updated.width = updated.right - updated.left;
    } else {
      updated.left = maxX - pos.width;
    }
  }

  if (pos.top < minY) {
    updated.top = minY;

    if (minY + pos.height > maxY) {
      updated.bottom = maxY;
      updated.height = updated.bottom - updated.top;
    } else {
      updated.bottom = minY + pos.height;
    }
  } else if (pos.bottom > maxY) {
    updated.bottom = maxY;

    if (maxY - pos.height < minY) {
      updated.top = minY;
      updated.height = updated.bottom - updated.top;
    } else {
      updated.top = maxY - pos.height;
    }
  }

  return updated;
}
